var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-dialog', {
    model: {
      value: _vm.isVisibleReportList,
      callback: function callback($$v) {
        _vm.isVisibleReportList = $$v;
      },
      expression: "isVisibleReportList"
    }
  }, [_c('dialog-template', [_c('flat-list-skeleton-loader', {
    attrs: {
      "slot": "content",
      "loading": _vm.loading
    },
    slot: "content"
  }, [_c('div', [_c('template-preview', {
    class: _vm.$style.template,
    attrs: {
      "title": _vm.$t('new.report'),
      "is-new": ""
    },
    on: {
      "edit": _vm.handleEdit
    }
  }), _vm._l(_vm.templates, function (template) {
    return _c('div', {
      key: template.id,
      class: _vm.$style.template
    }, [_c('template-preview', {
      attrs: {
        "title": template.name
      },
      on: {
        "edit": function edit($event) {
          return _vm.handleEdit(template);
        },
        "delete": function _delete($event) {
          return _vm.handleDelete(template);
        },
        "rename": function rename($event) {
          return _vm.handleRename(template);
        }
      }
    })], 1);
  })], 2)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }